module.exports = __webpack_public_path__ + "img/SIKH GREEN.9c77087.svg";